import { render, staticRenderFns } from "./ed-lesson-nav-link.vue?vue&type=template&id=204eccf4&scoped=true&"
import script from "./ed-lesson-nav-link.ts?vue&type=script&lang=js&"
export * from "./ed-lesson-nav-link.ts?vue&type=script&lang=js&"
import style0 from "./ed-lesson-nav-link.scss?vue&type=style&index=0&id=204eccf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204eccf4",
  null
  
)

export default component.exports